import { useState, useEffect } from "react";
import { fetchWithToken } from "../utils/fetchWithToken";
import "../assets/css/RegisterClientModal.css";
import { useNavigate } from "react-router-dom";

function RegisterClientModal({ isOpen, onClose }) {
    const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    nome: "",
    site: "",
    segmento: "",
    produto: "",
    publicoAlvo: "",
    descricao: "",
  });

  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const { nome } = formData;
    if (nome.trim()) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [formData]);

  const agencyId = sessionStorage.getItem("REACT_APP_AGENCY_ID");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      agencyId,
      ...formData,
      funil: "E-COMMERCE",
      status: "ativo",
    };

    try {
      const response = await fetchWithToken(
        "https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/clients/register",
        {
          method: "POST",
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`Erro ao cadastrar cliente: ${response.status}`);
      }

      showNotification("Cliente cadastrado com sucesso!");
      onClose();
      setTimeout(() => navigate('/team'), 1000);
    } catch (error) {
      console.error("Erro:", error);
    }
  };

  if (!isOpen) return null;

  const showNotification = (message) => {
    const notification = document.createElement("div");
    notification.className = "refresh-notification";
    notification.innerHTML = `
      <i class="ti ti-check"></i>
      <span>${message}</span>
    `;

    document.body.appendChild(notification);

    setTimeout(() => {
      notification.classList.add("show");
    }, 10);

    setTimeout(() => {
      notification.classList.remove("show");
      setTimeout(() => {
        document.body.removeChild(notification);
      }, 300);
    }, 3000);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="ad-accounts-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-section">
          <div className="modal-title-container">
            <h2 className="modal-title">Cadastrar Cliente</h2>
            <p className="modal-subtitle">Preencha os dados abaixo</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="data-sources-section">
          <label className="data-source-label">Nome:</label>
          <input type="text" className="input-modal" name="nome" value={formData.nome} onChange={handleChange} required />

          <label className="data-source-label">Site:</label>
          <input type="url" className="input-modal" name="site" value={formData.site} onChange={handleChange} />

          <label className="data-source-label">Segmento:</label>
          <input type="text" className="input-modal" name="segmento" value={formData.segmento} onChange={handleChange} />

          <label className="data-source-label">Produto:</label>
          <input type="text" className="input-modal" name="produto" value={formData.produto} onChange={handleChange} />

          <label className="data-source-label">Público Alvo:</label>
          <input type="text" className="input-modal" name="publicoAlvo" value={formData.publicoAlvo} onChange={handleChange} />

          <label className="data-source-label">Descrição:</label>
          <input type="text" className="input-modal" name="descricao" value={formData.descricao} onChange={handleChange} />

          <div className="navigation-container" style={{ marginTop: "40px" }}>
            <button
              type="submit"
              className="next-button"
              style={{
                backgroundColor: isFormValid ? "#4285f3" : "#eff5ff",
                color: isFormValid ? "#ffffff" : "#c6dcff",
                cursor: isFormValid ? "pointer" : "not-allowed",
              }}
              disabled={!isFormValid}
            >
              Cadastrar
            </button>
          </div>
        </form>

        <button className="close-icon-button" onClick={onClose}>
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/6f31e91f704d88d74c30016ba7766049716b602f?placeholderIfAbsent=true"
            className="close-icon"
            alt="Fechar"
          />
        </button>
      </div>
    </div>
  );
}

export default RegisterClientModal;
